import { useState } from "react";
import { Megaphone } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { BlastComposer } from "@/components/marketing/BlastComposer";
import { BlastHistory } from "@/components/marketing/BlastHistory";
import { AuditEmails } from "@/components/marketing/AuditEmails";
import { MissingEmails } from "@/components/marketing/MissingEmails";
import { PromoLibrary } from "@/components/marketing/PromoLibrary";
import { PromoResults } from "@/components/marketing/PromoResults";
import { useAuth } from "@/context/AuthContext";

export default function MarketingPage() {
  const [tab, setTab] = useState("blast");
  const [n, setN] = useState(0);
  const { user } = useAuth();
  const admin = user?.role === "admin";
  return (
    <div className="space-y-4" data-testid="marketing-page">
      <div><h1 className="text-2xl font-black text-slate-900 flex items-center gap-2"><Megaphone className="w-6 h-6 text-blue-600" />Marketing</h1>
        <p className="text-sm text-slate-500">{admin ? "Email and text blasts, promotions for your reps, audit summaries, and trial offers. Send to everyone or only the clients you choose." : "Email and text blasts to your own prospects and clients, plus the promotions you can send from the Call Center."}</p></div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex-wrap h-auto">
          <TabsTrigger value="blast" data-testid="mk-tab-blast">New blast</TabsTrigger>
          <TabsTrigger value="claim" data-testid="mk-tab-claim">Claim Your Page</TabsTrigger>
          <TabsTrigger value="history" data-testid="mk-tab-history">Sent</TabsTrigger>
          <TabsTrigger value="promos" data-testid="mk-tab-promos">Promotions</TabsTrigger>
          <TabsTrigger value="results" data-testid="mk-tab-results">Promo results</TabsTrigger>
          {admin && <TabsTrigger value="audit" data-testid="mk-tab-audit">Audit summaries</TabsTrigger>}
          {admin && <TabsTrigger value="missing" data-testid="mk-tab-missing">Missing emails</TabsTrigger>}
        </TabsList>
        <TabsContent value="blast"><BlastComposer onSent={() => { setN(n + 1); setTab("history"); }} /></TabsContent>
        <TabsContent value="claim"><BlastComposer claim onSent={() => { setN(n + 1); setTab("history"); }} /></TabsContent>
        <TabsContent value="history"><BlastHistory reload={n} /></TabsContent>
        <TabsContent value="promos"><PromoLibrary admin={admin} /></TabsContent>
        <TabsContent value="results"><PromoResults admin={admin} /></TabsContent>
        {admin && <TabsContent value="audit"><AuditEmails /></TabsContent>}
        {admin && <TabsContent value="missing"><MissingEmails /></TabsContent>}
      </Tabs>
    </div>
  );
}
